import React from 'react';
import { ProfileSC, FormSection } from './profile.styled';
import { PasswordForm } from '../components/profile/password';

function PasswordChangeView() {
  return (
    <div className="container">
      <ProfileSC>
        <FormSection id="profile-info">
          <PasswordForm />
        </FormSection>
      </ProfileSC>
    </div>
  );
}

export default PasswordChangeView;
